"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _some2 = _interopRequireDefault(require("lodash/some"));

var _every2 = _interopRequireDefault(require("lodash/every"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableColResizer = _interopRequireDefault(require("./TableColResizer"));

var _TableUtils = require("./TableUtils");

var _Sorter = _interopRequireWildcard(require("../Sorter/Sorter"));

var _TableRowSelection = require("./TableRowSelection");

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Header inside Table
 */
var TableHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableHeader, _React$Component);

  function TableHeader() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TableHeader)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.handleHeaderClick = function (column) {
      if (column.sorterElement) {
        column.sorterElement.toggleSortOrder();
      }
    }, _this.handleColumnResize = function (e, index) {
      var _this$props = _this.props,
          columnKey = _this$props.columnKey,
          eventHandlers = _this$props.eventHandlers,
          structure = _this$props.structure;
      var right = e.pageX;

      var left = _this.thResizableElements[index].getBoundingClientRect().left;

      var currentWidth = _this.thResizableElements[index].getBoundingClientRect().width;

      var newWidth = right - left;

      if (newWidth < TableHeader.MIN_COLUMN_WIDTH) {
        newWidth = TableHeader.MIN_COLUMN_WIDTH;
      }

      var updatedStructure = (0, _cloneDeep2.default)(structure);

      if (!updatedStructure.columnWidths) {
        updatedStructure.columnWidths = {};
      } // Resizing will affect the thElement in index and index +1


      var diffWidth = newWidth - currentWidth;

      var nextColWidth = _this.thResizableElements[index + 1].getBoundingClientRect().width;

      var nextColNewWidth = nextColWidth - diffWidth;

      if (nextColNewWidth < TableHeader.MIN_COLUMN_WIDTH) {
        // Prevent current column from expanding when next column becomes less than MIN_COLUMN_WIDTH
        var offset = TableHeader.MIN_COLUMN_WIDTH - nextColNewWidth;
        newWidth = newWidth - offset;
        nextColNewWidth = TableHeader.MIN_COLUMN_WIDTH;
      }

      var columns = (0, _TableUtils.flattenResizableColumns)(_this.props.columns);
      var colKeyVal = columns[index][columnKey];
      updatedStructure.columnWidths[colKeyVal] = "".concat(newWidth, "px");
      var nextColKeyVal = columns[index + 1][columnKey];
      updatedStructure.columnWidths[nextColKeyVal] = "".concat(nextColNewWidth, "px");
      eventHandlers.handleColumnResize(updatedStructure);
    }, _temp));
  }

  _createClass(TableHeader, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("thead", null, this.renderHeaderRows());
    }
    /**
     * Render the rows in the header
     * @returns {Array} - Array of tr elements containing th elements
     */

  }, {
    key: "renderHeaderRows",
    value: function renderHeaderRows() {
      var _this$props2 = this.props,
          customProps = _this$props2.customProps,
          columns = _this$props2.columns;
      var headerRows = [];
      var headerRowsData = this.getHeaderRows(columns); // Go through the header rows and calculate the rowSpan and colSpan
      // of each column depending how the column groups are setup

      for (var i = 0; i < headerRowsData.length; i++) {
        var rowColumns = headerRowsData[i];

        for (var j = 0; j < rowColumns.length; j++) {
          var rowSpan = headerRowsData.length - i;
          var colSpan = 1;

          if (rowColumns[j].group && rowColumns[j].group.length) {
            var rowsRemaining = headerRowsData.length - i - 1;
            rowSpan -= rowsRemaining;
            colSpan = this.getColSpan(rowColumns[j]);
          } // TODO (Deprecated columns.headerProps)


          if (!rowColumns[j].headerProps) {
            if (customProps && customProps.headerProps) {
              rowColumns[j].headerProps = customProps.headerProps(rowColumns[j]);
            } else {
              rowColumns[j].headerProps = {};
            }
          }

          if (rowSpan > 1) {
            rowColumns[j].headerProps.rowSpan = rowSpan;
          }

          if (colSpan > 1) {
            rowColumns[j].headerProps.colSpan = colSpan;
          }
        }

        headerRows.push(this.renderHeaderRow(headerRowsData, i));
      }

      return headerRows;
    }
    /**
     * Render a specific header row
     * @param {Array} headerRows - Header row data to render
     * @param {number} index - Index of the row to render
     * @returns {ReactElement} - tr element to be rendered
     */

  }, {
    key: "renderHeaderRow",
    value: function renderHeaderRow(headerRows, index) {
      var _this2 = this;

      var _this$props3 = this.props,
          columnKey = _this$props3.columnKey,
          editRow = _this$props3.editRow,
          rowAction = _this$props3.rowAction,
          rowExpand = _this$props3.rowExpand,
          rowSelection = _this$props3.rowSelection,
          sort = _this$props3.sort,
          structure = _this$props3.structure;
      var headerRow = headerRows[index];
      var headerCells = [];
      this.thResizableElements = [];
      var isFirstHeaderRow = index === 0;

      if (isFirstHeaderRow && rowSelection) {
        headerCells.push(_react.default.createElement("th", {
          key: "colSelection",
          className: "selection-column",
          rowSpan: headerRows.length
        }, this.renderRowSelectionBox()));
      } // Flattened array of columns that will have column resizer


      var flattenedColumns = (0, _TableUtils.flattenColumns)(this.props.columns); // Flattened array of columns that are used for resizing. If a column has a group,
      // it is the group that determines the width of the column so that specific column
      // itself is not resizable

      var flattenedResizableColumns = (0, _TableUtils.flattenResizableColumns)(this.props.columns);

      var _loop = function _loop(i) {
        var column = headerRow[i];
        var hasSorter = sort && sort.sortable ? sort.sortable.indexOf(column[columnKey]) > -1 : false;
        var flattenedColumnsIndex = (0, _findIndex2.default)(flattenedColumns, function (flattenedColumn) {
          return flattenedColumn[columnKey] === column[columnKey];
        });
        var hasColumnResizer = false;

        if (structure && structure.columnResize && flattenedColumnsIndex > -1) {
          // If columnResize is true, then all columns will be resizable except the last
          // If columnResize is an object, then the properties of the object will define
          // what is resizable
          if (structure.columnResize === true || _typeof(structure.columnResize) === 'object' && structure.columnResize[column[columnKey]] === true) {
            hasColumnResizer = true;
          }
        } // When user drags a column with children columns defined in a group, it is
        // actually resizing the last child by changing its width which will also update
        // the column the user is dragging


        var resizableColumn = hasColumnResizer ? (0, _TableUtils.getResizableColumn)(flattenedColumns[flattenedColumnsIndex]) : {};
        var flattenedResizableColumnsIndex = (0, _findIndex2.default)(flattenedResizableColumns, function (flattenedResizableColumn) {
          return resizableColumn[columnKey] === flattenedResizableColumn[columnKey];
        });

        if (hasColumnResizer && _typeof(structure.columnResize) === 'object') {
          // Check to see if the next column can be resized. If not, then the current column
          // shouldn't be resizable either because it would affect the width of the next column
          var nextColumn = flattenedResizableColumns[flattenedResizableColumnsIndex + 1];

          if (structure.columnResize[nextColumn[columnKey]] !== true) {
            hasColumnResizer = false;
          }
        }

        var isLastColumn = flattenedResizableColumnsIndex === flattenedResizableColumns.length - 1;

        var columnResizer = _react.default.createElement(_TableColResizer.default, {
          key: "col-resizer-".concat(column[columnKey]),
          onClick: function onClick(e) {
            e.stopPropagation();
          },
          onResize: function onResize(e) {
            return _this2.handleColumnResize(e, flattenedResizableColumnsIndex);
          }
        });

        var headerProps = column.headerProps || {}; // If another header cell has a colspan that spans into this cell, we
        // need a way to not show this cell. Since 0 is a valid value for colspan
        // we'll use -1 as a special value to not render this cell

        if (headerProps.colSpan !== -1) {
          headerCells.push(_react.default.createElement("th", _extends({
            key: "col-".concat(column[columnKey]),
            className: (0, _classnames.default)(column.className, hasSorter ? 'has-sorter' : ''),
            "data-text-align": column.textAlign,
            ref: function ref(thElement) {
              if (resizableColumn[columnKey] === column[columnKey]) {
                _this2.thResizableElements[flattenedResizableColumnsIndex] = thElement;
              }
            },
            onClick: function onClick() {
              return _this2.handleHeaderClick(column);
            }
          }, headerProps), _react.default.createElement("span", null, column.title), hasSorter ? _this2.renderSorter(column) : null, hasColumnResizer && !isLastColumn ? columnResizer : null));
        }
      };

      for (var i = 0; i < headerRow.length; i++) {
        _loop(i);
      }

      if (rowAction) {
        headerCells.push(_react.default.createElement("th", {
          key: "rowAction",
          className: "row-action"
        }));
      }

      if (isFirstHeaderRow && rowExpand) {
        headerCells.push(_react.default.createElement("th", {
          key: "rowExpand",
          className: "row-expand",
          rowSpan: headerRows.length
        }));
      }

      if (isFirstHeaderRow && editRow) {
        headerCells.push(_react.default.createElement("th", {
          key: "editRow",
          className: "edit-row",
          rowSpan: headerRows.length
        }));
      }

      return _react.default.createElement("tr", {
        key: index
      }, headerCells);
    }
    /**
     * Get the colSpan of a column based on how column groups are setup
     * @param {Object} column - Column data objcect
     * @returns {number} - colSpan value
     */

  }, {
    key: "getColSpan",
    value: function getColSpan(column) {
      var colSpan = 0;

      if (column.group && column.group.length) {
        for (var i = 0; i < column.group.length; i++) {
          colSpan += this.getColSpan(column.group[i]);
        }
      } else {
        colSpan = 1;
      }

      return colSpan;
    }
    /**
     * Recursively get data of how column headers will be rendered indexed by row
     * @param {Array} columns - Array of column data objects
     * @param {number} rowIndex - Row index to populate column data
     * @param {Array} rows - Array data indexed by rows which will be returned
     * @returns {Array} - Array of column header data indexed by row
     */

  }, {
    key: "getHeaderRows",
    value: function getHeaderRows(columns) {
      var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var rows = arguments.length > 2 ? arguments[2] : undefined;
      rows = rows || [];
      rows[rowIndex] = rows[rowIndex] || [];

      for (var i = 0; i < columns.length; i++) {
        var column = columns[i];

        if (column.group) {
          this.getHeaderRows(column.group, rowIndex + 1, rows);
        }

        rows[rowIndex].push(_objectSpread({}, column));
      }

      return rows;
    }
    /**
     * Render sorter component in column header
     * @param {object} column - Column object
     * @returns {element} - The sorter element
     */

  }, {
    key: "renderSorter",
    value: function renderSorter(column) {
      var _this$props4 = this.props,
          columnKey = _this$props4.columnKey,
          eventHandlers = _this$props4.eventHandlers,
          sort = _this$props4.sort;
      var hasSortOrder = sort.order && sort.column && sort.column === column[columnKey];
      var sortOrder = hasSortOrder ? sort.order : _Sorter.SORT_ORDER_CONST.NONE;
      return _react.default.createElement(_Sorter.default, {
        type: sort.type,
        sortOrder: sortOrder,
        onSortOrderChanged: function onSortOrderChanged(newSortOrder) {
          eventHandlers.handleSortOrderChange(newSortOrder === _Sorter.SORT_ORDER_CONST.NONE ? '' : newSortOrder, column[columnKey]);
        },
        ref: function ref(sorter) {
          column.sorterElement = sorter;
        }
      });
    }
    /**
     * Render for row selection box
     * @returns {element} - The selection box element
     */

  }, {
    key: "renderRowSelectionBox",
    value: function renderRowSelectionBox() {
      var _this$props5 = this.props,
          dataSource = _this$props5.dataSource,
          eventHandlers = _this$props5.eventHandlers,
          rowKey = _this$props5.rowKey,
          rowSelection = _this$props5.rowSelection;
      var selected = rowSelection.selected;
      var rowSelectionType = rowSelection.type;
      var selectionBox = null; // If rowSelectionType is not defined, it should default to checkbox

      if (!rowSelectionType || rowSelectionType === _TableRowSelection.ROW_SELECTION_TYPES.CHECKBOX) {
        var rowKeys = dataSource.map(function (row) {
          return row[rowKey];
        }); // If the rowKeys in dataSource are all in selected, then all
        // currently displayed rows are selected

        if (rowKeys.length && (0, _every2.default)(rowKeys, function (key) {
          return selected.indexOf(key) >= 0;
        })) {
          selectionBox = _react.default.createElement(_Checkbox.default, {
            id: "unselect-all",
            checked: true,
            onChange: function onChange() {
              return eventHandlers.handleRowUnselectAll(rowKeys);
            }
          });
        } else if ((0, _some2.default)(rowKeys, function (key) {
          return selected.indexOf(key) >= 0;
        })) {
          // If only some of the rows are selected
          selectionBox = _react.default.createElement(_Checkbox.default, {
            id: "partial-select",
            type: "partial-check",
            checked: true,
            onChange: function onChange() {
              return eventHandlers.handleRowSelectAll(rowKeys);
            }
          });
        } else {
          selectionBox = _react.default.createElement(_Checkbox.default, {
            id: "select-all",
            checked: false,
            onChange: function onChange() {
              return eventHandlers.handleRowSelectAll(rowKeys);
            }
          });
        }
      }

      return selectionBox;
    }
    /**
     * Handles click to header
     * @param {object} column - A column from columns data source
     */

  }]);

  return TableHeader;
}(_react.default.Component);

exports.default = TableHeader;
TableHeader.MIN_COLUMN_WIDTH = 40;
TableHeader.defaultProps = {};
TableHeader.propTypes = {
  /**
   * Key used to uniquely identify a column
   */
  columnKey: _propTypes.default.string,

  /**
   * Array of column objects
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Custom props to pass into table elements
   */
  customProps: _propTypes.default.object,

  /**
   * Data source for table
   */
  dataSource: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Object with edit row config
   */
  editRow: _propTypes.default.object,

  /**
   * Table event handlers
   */
  eventHandlers: _propTypes.default.object,

  /**
   * Object with row action options
   */
  rowAction: _propTypes.default.object,

  /**
   * Object with row expand options
   */
  rowExpand: _propTypes.default.object,

  /**
   * Key used to uniquely identify a row
   */
  rowKey: _propTypes.default.string,

  /**
   * Object with row selection options
   */
  rowSelection: _propTypes.default.object,

  /**
   * Object with sort info
   */
  sort: _propTypes.default.object,

  /**
   * Structure of table
   */
  structure: _propTypes.default.object
};